// extracted by mini-css-extract-plugin
export default {"overlay":"mw-z","bodyOpen":"nw-z","content":"ow-z","header":"pw-z","close":"qw-z","closeNoHeading":"rw-z"};